import * as moment from "moment";
export const advDeclineStreamingUpdated = (data, stream) => {
    return data.map((z) => {
        if (z.symbol === stream.symbol) {
            return Object.assign(Object.assign({}, z), { low: stream.low, high: stream.high, target: stream.target });
        }
        return z;
    });
};
export const advDeclineQuoteStreamingUpdated = (data, stream) => {
    return data.map((z) => {
        return Object.assign(Object.assign({}, z), { stockAdvanceList: z.stockAdvanceList.map((x) => {
                if (x.symbol === stream.symbol) {
                    return Object.assign(Object.assign({}, x), { change: stream.changePrice, changePercentage: stream.changePercentage, StocklatestTradingPrice: stream.curPrice });
                }
                return x;
            }), stockkDeclineList: z.stockkDeclineList.map((n) => {
                if (n.symbol === stream.symbol) {
                    return Object.assign(Object.assign({}, n), { change: stream.changePrice, changePercentage: stream.changePercentage, StocklatestTradingPrice: stream.curPrice });
                }
                return n;
            }) });
    });
};
export const indicesStreamingUpdated = (data, streaming) => {
    return data.map((x) => {
        if (x.symbol) {
            if ((x === null || x === void 0 ? void 0 : x.symbol) === streaming.symbol) {
                return Object.assign(Object.assign({}, x), { latestTradePrice: streaming.curPrice, high: x.high < streaming.high ? streaming.high : x.high, low: x.low > streaming.low ? streaming.low : x.low });
            }
        }
        return x;
    });
};
export const indicesViewAllStreamingUpdated = (data, streaming) => {
    return data.map((x) => {
        if (x.symbol) {
            if ((x === null || x === void 0 ? void 0 : x.symbol) === streaming.symbol) {
                return Object.assign(Object.assign({}, x), { changePercentage: streaming.changePercentage, changePrice: streaming.changePrice, latestTradePrice: streaming.curPrice, status: streaming.marketStatus, lastUpdatedDate: moment(streaming.updatedTime).format("DD-MMM-YY"), lastUpdatedTime: moment(streaming.updatedTime).format("hh:mm:ss A"), high: streaming.high, low: streaming.low });
            }
        }
        return x;
    });
};
export const marketStreamingUpdate = (data, streaming) => {
    return data.map((x) => {
        if (x.symbol) {
            if ((x === null || x === void 0 ? void 0 : x.symbol) === streaming.symbol) {
                return Object.assign(Object.assign({}, x), { changePercentage: streaming.changePercentage, changePrice: streaming.changePrice, latestTradingPrice: streaming.curPrice, 
                    // status: streaming.marketStatus, //in pending for now once kartik get back we can uncommit
                    lastUpdatedDate: moment(streaming.updatedTime).format("DD-MMM-YY"), lastUpdatedTime: moment(streaming.updatedTime).format("hh:mm:ss A") });
            }
        }
        return x;
    });
};
export const drivingMarketStreamingUpdate = (data, streaming) => {
    return data.map((x) => {
        if (x.symbol) {
            if ((x === null || x === void 0 ? void 0 : x.symbol) === streaming.symbol) {
                return Object.assign(Object.assign({}, x), { changePercentage: streaming.changePercentage, changePrice: streaming.changePrice, latestTradingPrice: streaming.curPrice, status: streaming.marketStatus, lastUpdatedDate: moment(streaming.updatedTime).format("DD-MMM-YY"), lastUpdatedTime: moment(streaming.updatedTime).format("hh:mm:ss A"), high: streaming.high, low: streaming.low });
            }
        }
        return x;
    });
};
export const marketTodayStream = (data, streaming) => {
    return data.map((x) => {
        if (x.symbol) {
            if (x.symbol === streaming.symbol) {
                return Object.assign(Object.assign({}, x), { change: streaming.changePrice, changePercentage: streaming.changePercentage, stockValue: streaming.curPrice, 
                    //status: streaming.marketStatus,//in pending for now once kartik get back we can uncommit
                    lastUpdatedDate: moment(streaming.updatedTime).format("DD-MMM-YY"), lastUpdatedTime: moment(streaming.updatedTime).format("hh:mm:ss A") });
            }
        }
        return x;
    });
};
